// extracted by mini-css-extract-plugin
export default {"platformTypes":"TradingPlatformModal_platformTypes__CV1iu","modalCard":"TradingPlatformModal_modalCard__Y3Cvy"};